import { useState } from "react";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import Button from "@mui/material/Button";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

//Material UI Icons
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

function SanityCheckDialogue({ open = false, errors = [], warnings = [], errorMessage = "", title = "", submitButton = "", closeButton = "", handleSubmit = () => {}, handleClose = () => {} }) {
    const [seeMore, setSeeMore] = useState([]);

    const handleSeeMore = (i) => {
        setSeeMore([...seeMore, i]);
    };

    const handleSeeLess = (i) => {
        const filteredArray = seeMore.filter((item) => item !== i);
        setSeeMore(filteredArray);
    };

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={"md"}
                open={open}
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 18,
                        textAlign: "center",
                    }}
                    // className="liner-light-blue-background-2"
                >
                    {title}
                    <IconButton
                        aria-label="close"
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "rgb(51, 94, 234) !important",
                        }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ padding: "0 !important" }}>
                    <Box sx={{ flexGrow: 1, marginBottom: "20px" }}>
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid
                                item
                                xs={12}
                                md={6}
                            >
                                <div style={{ width: "95%" }}>
                                    <div
                                        style={{
                                            backgroundColor: "rgb(255,0,0,0.1)",
                                            backgroundImage: "linear-gradient(to right, rgb(255,0,0,0.1) , white)",
                                            border: "2px solid",
                                            borderImageSlice: "1",
                                            borderWidth: "85%",
                                            borderImageSource: "linear-gradient(to right, rgb(255,0,0,0.8) , white)",
                                            borderLeft: "0",
                                            borderRight: "0",
                                            borderTop: "0",
                                            padding: "20px 40px 10px 40px",
                                        }}
                                    >
                                        <WarningIcon style={{ color: "rgb(255,0,0,.8)" }} />
                                        <span
                                            style={{
                                                fontSize: "20px",
                                                fontWeight: "500",
                                                paddingLeft: "10px",
                                            }}
                                        >
                                            Errors
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            margin: "20px -3px",
                                            padding: "0px 10px",
                                        }}
                                    >
                                        <ul className="dialog-list">
                                            {errors.map((item, index) => (
                                                <li key={index}>
                                                    <span className="dialog-list-icon">
                                                        <PlayArrowIcon />
                                                    </span>
                                                    <span style={{ wordBreak: "break-word" }}>{item}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={6}
                            >
                                <div style={{ width: "95%" }}>
                                    <div
                                        style={{
                                            backgroundColor: "rgb(255,234,0,0.1)",
                                            backgroundImage: "linear-gradient(to right, rgb(255,234,0,0.1) , white)",
                                            border: "2px solid",
                                            borderImageSlice: "1",
                                            borderWidth: "85%",
                                            borderImageSource: "linear-gradient(to right, rgb(255,234,0,0.8) , white)",
                                            borderLeft: "0",
                                            borderRight: "0",
                                            borderTop: "0",
                                            padding: "20px 40px 10px 40px",
                                        }}
                                    >
                                        <WarningIcon style={{ color: "rgb(255,234,0,.8)" }} />
                                        <span
                                            style={{
                                                fontSize: "20px",
                                                fontWeight: "500",
                                                paddingLeft: "10px",
                                            }}
                                        >
                                            Warnings
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            margin: "20px -3px",
                                            padding: "0px 10px",
                                            borderLeft: "3px solid #D2D2D2",
                                        }}
                                    >
                                        <ul className="dialog-list">
                                            {warnings.map((item, index) => (
                                                <li key={index}>
                                                    <span className="dialog-list-icon">
                                                        <PlayArrowIcon />
                                                    </span>
                                                    {item.length > 350 ? (
                                                        <>
                                                            <span style={{ wordBreak: "break-word" }}>{item.slice(0, 250)}</span>
                                                            {!seeMore.includes(index) && (
                                                                <Button
                                                                    size="small"
                                                                    style={{
                                                                        textTransform: "none",
                                                                    }}
                                                                    onClick={() => handleSeeMore(index)}
                                                                >
                                                                    {"   ... See more"}
                                                                </Button>
                                                            )}
                                                            {seeMore.includes(index) && <span style={{ wordBreak: "break-word" }}>{item.slice(250)}</span>}
                                                            {seeMore.includes(index) && (
                                                                <Button
                                                                    size="small"
                                                                    style={{
                                                                        textTransform: "none",
                                                                    }}
                                                                    onClick={() => handleSeeLess(index)}
                                                                >
                                                                    {"   ... See less"}
                                                                </Button>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span style={{ wordBreak: "break-word" }}>{item}</span>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                    <div className="dialog-errorMessage">{errorMessage}</div>
                </DialogContent>
                <DialogActions>
                    <Box sx={{ width: "100%", textAlign: "center", paddingBottom: "16px" }}>
                        <Button
                            size="small"
                            className={errors.length !== 0 || (errors.length === 0 && warnings.length === 0) ? "custom-btn custom-btn--upload-reset disabled" : "custom-btn liner-light-blue-background custom-btn--upload-reset"}
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={errors.length !== 0 || (errors.length === 0 && warnings.length === 0)}
                        >
                            {submitButton}
                        </Button>
                        <Button
                            size="small"
                            className="custom-btn custom-btn--upload-reset"
                            variant="outlined"
                            onClick={handleClose}
                        >
                            {closeButton}
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </div>
    );
}

// Typechecking props for the AlertDialogue
SanityCheckDialogue.propTypes = {
    open: PropTypes.bool,
    errors: PropTypes.array,
    warnings: PropTypes.array,
    title: PropTypes.string,
    errorMessage: PropTypes.string,
    submitButton: PropTypes.string,
    closeButton: PropTypes.string,
    handleSubmit: PropTypes.func,
    handleClose: PropTypes.func,
};

export default SanityCheckDialogue;
